import {
  pairingTypes,
  pairingResults,
  pairingSources,
  pairingPromotions
} from "src/modules/pairing/constants";
import { relogAsDifferentUser } from "src/modules/auth/duck/epics";
import { updatePairedDevice } from "src/modules/device/duck/actions";

import * as actions from "../actions";
import * as selectors from "../selectors";

const log = window.require("electron-log");

export default function onReceivedResponse({
  flow,
  messenger,
  app,
  didLogIn,
  didSignUp
}) {
  return async (dispatch, getState) => {
    const state = getState();
    const response = selectors.getResponse(state);

    const responder = selectors.getResponder(state);
    const pairingSource = selectors.getPairingSource(state);
    const foundHotelPromotion =
      response?.promotion?.[pairingPromotions.HOTEL_TABLET];

    function shouldRelog(pairingType) {
      return (
        pairingType === pairingTypes.THEIR_FAMILY ||
        pairingType === pairingTypes.THEIR_FAMILY_CREATE
      );
    }

    switch (response.result) {
      case pairingResults.REJECTED:
      case pairingResults.FAILED:
      case pairingResults.PAIRING_IN_PROGRESS:
        pairingSource === pairingSources.AUTO_PAIRING
          ? flow.push("nearby-devices")
          : flow.push("scan-qr-code");
        return;
      case pairingResults.ACCEPTED: {
        if (
          response.pairingType === pairingTypes.INITIAL &&
          foundHotelPromotion
        ) {
          flow.push("promotion", {
            state: { promo: foundHotelPromotion }
          });
          return;
        }
        if (response.pairingType === pairingTypes.INITIAL) {
          flow.push("account-request");
          return;
        }
        if (shouldRelog(response.pairingType)) {
          try {
            flow.push("synchronizing");
            await dispatch(
              relogAsDifferentUser({
                authId: response.authId,
                otp: response.otp,
                messenger,
                app
              })
            );
            flow.push("requester-success", {
              state: {
                didLogIn,
                didSignUp
              }
            });
            return;
          } catch (error) {
            log.error(error);
            dispatch(actions.pairingFailed());
            pairingSource === pairingSources.AUTO_PAIRING
              ? flow.push("nearby-devices")
              : flow.push("scan-qr-code");
            return;
          }
        }
        if (response.pairingType === pairingTypes.DEVICES) {
          dispatch(
            updatePairedDevice({
              jid: responder.jid,
              group: "others",
              name: response.deviceName,
              familyName: response.familyName
            })
          );
          flow.push("requester-success");
          return;
        }
        if (foundHotelPromotion) {
          flow.push("redeeming", {
            state: {
              promo: foundHotelPromotion
            }
          });
          return;
        }
        flow.push("requester-success", {
          state: {
            didLogIn,
            didSignUp
          }
        });
        return;
      }
      default:
        dispatch(actions.pairingFailed());
        pairingSource === pairingSources.AUTO_PAIRING
          ? flow.push("nearby-devices", { direction: "previous" })
          : flow.push("scan-qr-code", { direction: "previous" });
        return;
    }
  };
}
